import { ButtonRadio, Checkbox, Trans } from '@/components'
import { MachineType } from '@/consts/machine'

interface AcceleratorTypeSelectorProps {
  value: MachineType
  onChange: (value: MachineType) => void
  isVgpuChecked: boolean
  onVgpuCheckedChange: (checked: boolean) => void
  showVgpuToggle?: boolean
}

export function AcceleratorTypeSelector({
  value,
  onChange,
  isVgpuChecked,
  onVgpuCheckedChange,
  showVgpuToggle = true,
}: AcceleratorTypeSelectorProps) {
  return (
    <section
      className="flex flex-col gap-2"
      data-ai-component="accelerator-filter"
      data-ai-state={isVgpuChecked ? 'vgpu-filter-enabled' : 'vgpu-filter-disabled'}
      data-ai-value={value === MachineType.CPU ? 'CPU' : 'GPU'}
    >
      <div className="text-secondary t-sb" id="accelerator-type-label">
        <Trans i18nKey="create.typeLabel">Accelerator Type</Trans>
      </div>
      <div className="flex gap-2">
        <ButtonRadio
          rootProps={{
            role: 'radiogroup',
            'aria-labelledby': 'accelerator-type-label',
            'data-ai-component': 'accelerator-type-options',
          }}
          value={value}
          items={[
            {
              label: 'GPU',
              value: MachineType.GPU,
              buttonProps: {
                role: 'radio',
                'aria-checked': value === MachineType.GPU,
                'data-ai-action': 'select-accelerator',
                'data-ai-state': value === MachineType.GPU ? 'selected' : 'unselected',
                'data-ai-value': 'GPU',
              },
            },
            {
              label: 'CPU',
              value: MachineType.CPU,
              buttonProps: {
                role: 'radio',
                'aria-checked': value === MachineType.CPU,
                'data-ai-action': 'select-accelerator',
                'data-ai-state': value === MachineType.CPU ? 'selected' : 'unselected',
                'data-ai-value': 'CPU',
              },
            },
          ]}
          onChange={onChange}
        />
        {value === MachineType.GPU && showVgpuToggle && (
          <div
            className="flex h-11 py-3 pr-4 pl-3 justify-center items-center gap-2 rounded-lg border border-neutral-200"
            data-ai-component="vgpu-filter"
            data-ai-state={isVgpuChecked ? 'checked' : 'unchecked'}
            data-ai-value={String(isVgpuChecked)}
          >
            <Checkbox
              className="t-sb"
              checked={isVgpuChecked}
              onChange={onVgpuCheckedChange}
              labelProps={{
                'data-ai-action': 'toggle-vgpus',
                'data-ai-state': isVgpuChecked ? 'checked' : 'unchecked',
                'data-ai-value': String(isVgpuChecked),
              }}
              inputProps={{
                'aria-label': 'Toggle vGPUs',
              }}
            >
              <Trans i18nKey="create.typeLabelVGPU">vGPUs</Trans>
            </Checkbox>
          </div>
        )}
      </div>
    </section>
  )
}
